import React, { useState, useEffect } from "react";
import { Table, Input, Button, Icon, Loader, Modal } from "semantic-ui-react";
import { map, size } from "lodash";
import { toast } from "react-toastify";
import { HeaderPage, CustomerForm } from "../../components/Admin";
import { ModalConfirm } from "../../components/Common";
import { useCustomer } from "../../hooks";

// Configuración → Clientes: la lista de clientes del restaurante (los mismos
// que se eligen en "Selecciona un cliente" al tomar un pedido).
export function CustomersAdmin() {
  const { getCustomers, deleteCustomer } = useCustomer();
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState(null);
  const [editing, setEditing] = useState(null); // {} = nuevo; cliente = editar
  const [toDelete, setToDelete] = useState(null);

  const load = async () => {
    try {
      setCustomers(await getCustomers(search));
    } catch (error) {
      setCustomers([]);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(load, 250);
    return () => clearTimeout(timeout);
  }, [search]);

  const onSaved = () => {
    setEditing(null);
    load();
  };

  const confirmDelete = async () => {
    const customer = toDelete;
    setToDelete(null);
    await deleteCustomer(customer.id);
    toast.success(`Cliente "${customer.full_name}" eliminado`);
    load();
  };

  return (
    <>
      <HeaderPage title="Clientes" btnTitle="Nuevo cliente" btnClick={() => setEditing({})} />

      <Input
        icon="search"
        iconPosition="left"
        placeholder="Buscar por nombre, teléfono o documento"
        value={search}
        onChange={(_, data) => setSearch(data.value)}
        style={{ width: "100%", maxWidth: 420, marginBottom: 16 }}
      />

      {customers === null ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : size(customers) === 0 ? (
        <p style={{ color: "#888" }}>
          {search
            ? "No se encontró ningún cliente."
            : 'Todavía no hay clientes. Se crean aquí o desde "Selecciona un cliente" al tomar un pedido.'}
        </p>
      ) : (
        <Table compact unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Cliente</Table.HeaderCell>
              <Table.HeaderCell>Documento</Table.HeaderCell>
              <Table.HeaderCell>Teléfono</Table.HeaderCell>
              <Table.HeaderCell>Dirección</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {map(customers, (customer) => (
              <Table.Row key={customer.id}>
                <Table.Cell>
                  <Icon name={customer.kind === "COMPANY" ? "building" : "user"} />{" "}
                  {customer.full_name}
                </Table.Cell>
                <Table.Cell>
                  {customer.doc_number ? `${customer.doc_type} ${customer.doc_number}` : "—"}
                </Table.Cell>
                <Table.Cell>{customer.phone || "—"}</Table.Cell>
                <Table.Cell>{customer.address || "—"}</Table.Cell>
                <Table.Cell textAlign="right" style={{ whiteSpace: "nowrap" }}>
                  <Button icon onClick={() => setEditing(customer)} title="Editar">
                    <Icon name="pencil" />
                  </Button>
                  <Button icon negative onClick={() => setToDelete(customer)} title="Eliminar">
                    <Icon name="close" />
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}

      <Modal open={!!editing} onClose={() => setEditing(null)} size="small" closeIcon>
        <Modal.Header>{editing?.id ? "Editar cliente" : "Nuevo cliente"}</Modal.Header>
        <Modal.Content>
          {editing && (
            <CustomerForm
              customer={editing.id ? editing : null}
              onSaved={onSaved}
              onCancel={() => setEditing(null)}
            />
          )}
        </Modal.Content>
      </Modal>

      <ModalConfirm
        show={!!toDelete}
        title="¿Eliminar este cliente?"
        content={
          toDelete &&
          `Se eliminará "${toDelete.full_name}". Sus ventas anteriores se conservan, pero quedarán sin cliente.`
        }
        onClose={() => setToDelete(null)}
        onCloseText="Volver"
        onConfirm={confirmDelete}
        onConfirmText="Sí, eliminar"
      />
    </>
  );
}
